import React, { useEffect } from 'react'
import './statdiv.scss'
import AOS from 'aos';
import 'aos/dist/aos.css';
import UserIcon from '../../../generic/icons/IconLib/UserIcon';
import CalendarCheckIcon from '../../../generic/icons/IconLib/CalendarCheckIcon';
import SettingsIcon from '../../../generic/icons/IconLib/SettingsIcon';



function Block() {
  
    useEffect(()=> {
        const counters = document.querySelectorAll('.stat-container__item');
        const speed = 400;
        counters.forEach(counter => {
            const updateCount = () => {
                const target = +counter.getAttribute('data-target');
                const count = +counter.innerText;
                // console.log(target);
                const inc = target / speed;
                //   console.log(inc);
                if(count < target){
                    counter.innerText = Math.ceil(count + inc);
                    setTimeout(updateCount, 1)
                } 
            }     
            updateCount()
        });

    }, [])
    AOS.init();
    return(
        <section className="stat" >
            <div className="stat-container" data-aos-once="true" data-aos="fade-up">
                <span className="stat-icon-user"><UserIcon /></span>
                <h2>לקוחות</h2>
                <div className="stat-container__item" data-target="150">0</div>
            </div>
            <div className="stat-container" data-aos-once="true" data-aos="fade-up">
                <span className="stat-icon-calendar"><CalendarCheckIcon /></span>
                <h2>מוניטין</h2>
                <div className="stat-container__item" data-target="23">0</div>
            </div>
            <div className="stat-container" data-aos-once="true" data-aos="fade-up">
                <span className="stat-icon-cog"><SettingsIcon /></span>
                <h2>משתמשים</h2>
                <div className="stat-container__item" data-target="500">0 </div>
            </div>
        </section>
    );
}

export default Block;